import { ROUTES } from 'services/utils/enums';
import { sendRequest } from 'services/api';

export const attachMediaToService = async function(params) {
    return sendRequest(ROUTES.SERVICE_ATTACH_MEDIA, params.serviceID, params.data);
};

export const cancelService = async function(params) {
    return sendRequest(ROUTES.SERVICE_CANCEL, params.serviceID);
};

export const approveSupplementService = async function(params) {
    return sendRequest(ROUTES.SERVICE_ACCEPT_SUPPLEMENT, params.serviceID);
};

export const declineSupplementService = async function(params) {
    return sendRequest(ROUTES.SERVICE_REJECT_SUPPLEMENT, params.serviceID);
};

export const requestReworkService = async function(params) {
    return sendRequest(ROUTES.SERVICE_REQUEST_REWORK, params.serviceID, params.data);
};

export const declineService = async function(params) {
    return sendRequest(ROUTES.SERVICE_DECLINE, params.serviceID);
};

export const acceptService = async function(params) {
    return sendRequest(ROUTES.SERVICE_ACCEPT, params.serviceID);
};

export const supplementService = async function(params) {
    return sendRequest(ROUTES.SERVICE_SUPPLEMENT, params.serviceID, params.data);
};

export const startService = async function(params) {
    return sendRequest(ROUTES.SERVICE_START, params.serviceID);
};

export const completeService = async function(params) {
    return sendRequest(ROUTES.SERVICE_COMPLETE, params.serviceID);
};

export const updateService = async function(params) {
    return sendRequest(ROUTES.SERVICE_UPDATE, params.serviceID, params.data);
};

export const subletService = async function(params) {
    return sendRequest(ROUTES.SERVICE_SUBLET, params.serviceID, params.data);
};
